import { BillType } from '@features/bills/enums/billType'
import { InvoiceType } from '@features/invoicesLegacy/types/invoiceType'
import { PayableSubjectType } from '@features/paymentReconciliationModal/types/payableSubjectType'
import { convertSubjectsIdsToReconciliationSubjects } from '@features/paymentReconciliationModal/utils/convertSubjectsIdsToReconciliationSubjects'
import { ReconciliationSuggestion } from '@modules-deprecated/bankReconciliation/types'

export const getReconcileInformationFromSuggestion = (suggestion: ReconciliationSuggestion) => {
  const banklineId = suggestion.transactions?.[0]?.id
  const reconcilableId = suggestion.reconcilables?.[0]?.id

  const reconcilableType = suggestion.reconcilables?.[0]?.type
  const subjectTypeMap: Record<string, PayableSubjectType> = {
    bill: BillType.Bill,
    invoice: InvoiceType.Invoice,
    externalInvoice: InvoiceType.ExternalInvoice,
  }
  const subjectType = reconcilableType ? (subjectTypeMap[reconcilableType] ?? InvoiceType.Invoice) : InvoiceType.Invoice
  const subjectId = reconcilableId.split(`:`)[1]

  const subject = convertSubjectsIdsToReconciliationSubjects([subjectId], subjectType)

  return { banklineId, subject }
}
